/**
 * Read a number as currency format
 * @param value
 * @returns
 */
export function NUMBER_TO_CURRENCY(value: number): string {
  if (!value) return ''

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

/**
 * Removes everything less [0-9] and negative (-)
 * @param value
 * @returns
 */
export function CURRENCY_TO_NUMBER(value: string): number {
  // remove unwanted texts
  let newValue = String(value).replace(/[^0-9-]/g, '')

  // negative transformation
  if (newValue.includes('-')) newValue = '-' + newValue.replace('-', '')

  // currency transform
  const currency = Number(newValue) / 100

  if (isNaN(currency)) return 0

  return currency
}
